import apiClient from './api';

export interface CreateCheckoutRequest {
  priceId: string;
  returnUrl: string;
}

export interface CreateCheckoutResponse {
  sessionId: string;
  checkoutUrl: string;
  message: string;
}

export interface CustomerPortalResponse {
  portalUrl: string;
  message: string;
}

export interface SubscriptionLimits {
  projects: number;
  episodes: number;
  autoTranscriptions: number;
  autoTranslations: number;
  isUnlimited: boolean;
}

export interface UsageStats {
  projectsCount: number;
  episodesCount: number;
  autoTranscriptionsCount: number;
  autoTranslationsCount: number;
  periodStart: string;
}

export interface SubscriptionStatus {
  tier: 'free' | 'basic' | 'premium' | 'pro';
  status: string;
  limits: SubscriptionLimits;
  usage: UsageStats;
  currentPeriodEnd?: string;
}

export const subscriptionService = {
  /**
   * Create a checkout session for subscribing to a plan
   */
  async createCheckout(request: CreateCheckoutRequest): Promise<CreateCheckoutResponse> {
    const response = await apiClient.post<CreateCheckoutResponse>(
      '/subscription/create-checkout',
      request
    );
    return response.data;
  },

  /**
   * Get the customer portal URL for managing subscriptions
   */
  async getCustomerPortal(): Promise<CustomerPortalResponse> {
    const response = await apiClient.get<CustomerPortalResponse>(
      '/subscription/customer-portal'
    );
    return response.data;
  },

  /**
   * Get the user's subscription status, limits, and usage
   */
  async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    const response = await apiClient.get<SubscriptionStatus>(
      '/subscription/status'
    );
    return response.data;
  },
};
